import "./main.css";
import {useStyleProps as $8Tpjb$useStyleProps, useFocusableRef as $8Tpjb$useFocusableRef, classNames as $8Tpjb$classNames} from "@react-spectrum/utils";
import {FocusRing as $8Tpjb$FocusRing} from "@react-aria/focus";
import $8Tpjb$react, {useRef as $8Tpjb$useRef, forwardRef as $8Tpjb$forwardRef} from "react";
import {useHover as $8Tpjb$useHover} from "@react-aria/interactions";
import {useProviderProps as $8Tpjb$useProviderProps} from "@react-spectrum/provider";
import {useSwitch as $8Tpjb$useSwitch} from "@react-aria/switch";
import {useToggleState as $8Tpjb$useToggleState} from "@react-stately/toggle";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ 


var $dfcff93ab25bb9b3$exports = {};

$parcel$export($dfcff93ab25bb9b3$exports, "focus-ring", () => $dfcff93ab25bb9b3$export$f39a09f249340e2a, (v) => $dfcff93ab25bb9b3$export$f39a09f249340e2a = v);
$parcel$export($dfcff93ab25bb9b3$exports, "i18nFontFamily", () => $dfcff93ab25bb9b3$export$8c4ee2c50c22c514, (v) => $dfcff93ab25bb9b3$export$8c4ee2c50c22c514 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "is-hovered", () => $dfcff93ab25bb9b3$export$b8813cd5d7824ce7, (v) => $dfcff93ab25bb9b3$export$b8813cd5d7824ce7 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-FocusRing-ring", () => $dfcff93ab25bb9b3$export$4109102f950813a6, (v) => $dfcff93ab25bb9b3$export$4109102f950813a6 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-FocusRing", () => $dfcff93ab25bb9b3$export$24c7f46a6e3605dd, (v) => $dfcff93ab25bb9b3$export$24c7f46a6e3605dd = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-FocusRing--quiet", () => $dfcff93ab25bb9b3$export$2927016961429360, (v) => $dfcff93ab25bb9b3$export$2927016961429360 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch", () => $dfcff93ab25bb9b3$export$89a9162656c0c38c, (v) => $dfcff93ab25bb9b3$export$89a9162656c0c38c = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch--ab", () => $dfcff93ab25bb9b3$export$dc5a33fddabf5882, (v) => $dfcff93ab25bb9b3$export$dc5a33fddabf5882 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch--quiet", () => $dfcff93ab25bb9b3$export$ce1b1dcfc10f3df4, (v) => $dfcff93ab25bb9b3$export$ce1b1dcfc10f3df4 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch-input", () => $dfcff93ab25bb9b3$export$38df7ea4ffef819a, (v) => $dfcff93ab25bb9b3$export$38df7ea4ffef819a = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch-label", () => $dfcff93ab25bb9b3$export$8f1a69021a3897b2, (v) => $dfcff93ab25bb9b3$export$8f1a69021a3897b2 = v);
$parcel$export($dfcff93ab25bb9b3$exports, "spectrum-ToggleSwitch-switch", () => $dfcff93ab25bb9b3$export$b82d06d1b520a22f, (v) => $dfcff93ab25bb9b3$export$b82d06d1b520a22f = v);
var $dfcff93ab25bb9b3$export$f39a09f249340e2a;
var $dfcff93ab25bb9b3$export$8c4ee2c50c22c514;
var $dfcff93ab25bb9b3$export$b8813cd5d7824ce7;
var $dfcff93ab25bb9b3$export$4109102f950813a6;
var $dfcff93ab25bb9b3$export$24c7f46a6e3605dd;
var $dfcff93ab25bb9b3$export$2927016961429360;
var $dfcff93ab25bb9b3$export$89a9162656c0c38c;
var $dfcff93ab25bb9b3$export$dc5a33fddabf5882;
var $dfcff93ab25bb9b3$export$ce1b1dcfc10f3df4;
var $dfcff93ab25bb9b3$export$38df7ea4ffef819a;
var $dfcff93ab25bb9b3$export$8f1a69021a3897b2;
var $dfcff93ab25bb9b3$export$b82d06d1b520a22f;
$dfcff93ab25bb9b3$export$f39a09f249340e2a = `XHynUq_focus-ring`;
$dfcff93ab25bb9b3$export$8c4ee2c50c22c514 = `XHynUq_i18nFontFamily`;
$dfcff93ab25bb9b3$export$b8813cd5d7824ce7 = `XHynUq_is-hovered`;
$dfcff93ab25bb9b3$export$4109102f950813a6 = `XHynUq_spectrum-FocusRing-ring`;
$dfcff93ab25bb9b3$export$24c7f46a6e3605dd = `XHynUq_spectrum-FocusRing ${$dfcff93ab25bb9b3$export$4109102f950813a6}`;
$dfcff93ab25bb9b3$export$2927016961429360 = `XHynUq_spectrum-FocusRing--quiet`;
$dfcff93ab25bb9b3$export$89a9162656c0c38c = `XHynUq_spectrum-ToggleSwitch`;
$dfcff93ab25bb9b3$export$dc5a33fddabf5882 = `XHynUq_spectrum-ToggleSwitch--ab`;
$dfcff93ab25bb9b3$export$ce1b1dcfc10f3df4 = `XHynUq_spectrum-ToggleSwitch--quiet`;
$dfcff93ab25bb9b3$export$38df7ea4ffef819a = `XHynUq_spectrum-ToggleSwitch-input`;
$dfcff93ab25bb9b3$export$8f1a69021a3897b2 = `XHynUq_spectrum-ToggleSwitch-label`;
$dfcff93ab25bb9b3$export$b82d06d1b520a22f = `XHynUq_spectrum-ToggleSwitch-switch`;






function $8341c396cee1c5fc$var$Switch(props, ref) {
    props = (0, $8Tpjb$useProviderProps)(props);
    let { isEmphasized: isEmphasized = false, isDisabled: isDisabled = false, autoFocus: autoFocus, children: children, ...otherProps } = props;
    let { styleProps: styleProps } = (0, $8Tpjb$useStyleProps)(otherProps);
    let { hoverProps: hoverProps, isHovered: isHovered } = (0, $8Tpjb$useHover)({
        isDisabled: isDisabled
    });
    let inputRef = (0, $8Tpjb$useRef)(null);
    let domRef = (0, $8Tpjb$useFocusableRef)(ref, inputRef);
    let state = (0, $8Tpjb$useToggleState)(props);
    let { inputProps: inputProps } = (0, $8Tpjb$useSwitch)(props, state, inputRef);
    return /*#__PURE__*/ (0, $8Tpjb$react).createElement("label", {
        ...styleProps,
        ...hoverProps,
        ref: domRef,
        className: (0, $8Tpjb$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($dfcff93ab25bb9b3$exports))), "spectrum-ToggleSwitch", {
            "spectrum-ToggleSwitch--quiet": !isEmphasized,
            "is-disabled": isDisabled,
            "is-hovered": isHovered
        }, styleProps.className)
    }, /*#__PURE__*/ (0, $8Tpjb$react).createElement((0, $8Tpjb$FocusRing), {
        focusRingClass: (0, $8Tpjb$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($dfcff93ab25bb9b3$exports))), "focus-ring"),
        autoFocus: autoFocus
    }, /*#__PURE__*/ (0, $8Tpjb$react).createElement("input", {
        ...inputProps,
        ref: inputRef,
        className: (0, $8Tpjb$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($dfcff93ab25bb9b3$exports))), "spectrum-ToggleSwitch-input")
    })), /*#__PURE__*/ (0, $8Tpjb$react).createElement("span", {
        className: (0, $8Tpjb$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($dfcff93ab25bb9b3$exports))), "spectrum-ToggleSwitch-switch")
    }), children && /*#__PURE__*/ (0, $8Tpjb$react).createElement("span", {
        className: (0, $8Tpjb$classNames)((0, (/*@__PURE__*/$parcel$interopDefault($dfcff93ab25bb9b3$exports))), "spectrum-ToggleSwitch-label")
    }, children));
}
/**
 * Switches allow users to turn an individual option on or off.
 * They are usually used to activate or deactivate a specific setting.
 */ const $8341c396cee1c5fc$export$b5d5cf8927ab7262 = /*#__PURE__*/ (0, $8Tpjb$forwardRef)($8341c396cee1c5fc$var$Switch);




export {$8341c396cee1c5fc$export$b5d5cf8927ab7262 as Switch};
//# sourceMappingURL=module.js.map
